import { useState, useEffect, useRef } from "react";
import RightTimeApi from "@/API";
import { FaPlusSquare } from "react-icons/fa";
import { IoTrashOutline } from "react-icons/io5";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { toast } from "react-toastify";

export default function CompanyImagesTab(props: any) {
  if (!props || !props.tabData) {
    console.error('CompanyImagesTab: props or props.tabData is undefined');
    return null;
  }
  
  const { updateSpinner, activeTab, company } = props.tabData;

  const [imageData, updateImageData] = useState([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null); // Create a ref for the file input

  useEffect(() => {
    getImageDataAsync()
  }, [activeTab]);

  function isOnThisTab() {
    return props && activeTab && activeTab === "images";
  }

  async function getImageDataAsync() {
    if (isOnThisTab()) {
      if (company.id) {
        updateSpinner(true);
        const resp = await RightTimeApi.getAsync("/CompanyImages/" + company.id);
        updateSpinner(false);
        if(resp && resp.ok && resp.jsonData && Array.isArray(resp.jsonData.images)) {
            updateImageData(resp.jsonData.images);
        };
      }
    }
  }

  async function onSelectImageAsync(e: any) {
    const files = Array.from(e.target.files);
    
    if (files.length === 0) 
      return;

    // Check authentication before attempting upload
    const userData = window.sessionStorage.getItem("User");
    if (!userData) 
      return;

    // Log token info (without exposing the actual token)
    try {
      const decodedUser = JSON.parse(atob(userData));
    } catch (error) {
      console.error("Error decoding user data:", error);
    }
    
    updateSpinner(true);

    const uploadPromises = files.map(async (file) => {
      try {
        const result = await RightTimeApi.postFileAsync("/Image/" + company.id, file);
        return result;
      } catch (error) {
        throw error;
      }
    });

    try {
      await Promise.all(uploadPromises);
      toast.success("Images uploaded successfully");
      getImageDataAsync();
    } catch (error) {
      console.error("Error uploading images:", error);
      if (error.status === 401) {
        toast.error("Server rejected authentication. This may be a server-side configuration issue with file uploads.");
      } else {
        toast.error(`Failed to upload images: ${error.message || 'Unknown error'}`);
      }
    } finally {
      updateSpinner(false);
      e.target.value = '';
    }
  }
  
  async function onDeleteFileAsync(e: any) {
    const imageId = e.currentTarget.getAttribute("data-imageid");
    const resp = await RightTimeApi.deleteAsync("/Image/" + imageId);
    if (resp && resp.ok) {
      toast.success("Image deleted successfully");
      getImageDataAsync();
    } else {
      toast.error("Failed to delete image");
    }
  }

  if (isOnThisTab()) {
    return (
      <>
      <div className="tableWrapper dimensionTable inline-block">
        <table>
          <caption>
            <span className="title">Images</span>
          </caption>
          <thead>
            <tr>
              <th>Id</th>
              <th>FileName</th>
              <th>Image</th>
              <th onClick={() => {
                console.log("Plus icon clicked, checking file input ref:", fileInputRef.current);
                if (fileInputRef.current) {
                  console.log("Triggering file input click");
                  fileInputRef.current.click();
                } else {
                  console.error("File input ref is null");
                }
              }}>
                <FaPlusSquare className="actionIcon plusIcon" />
              </th>
            </tr>
          </thead>
          <tbody>
            {imageData && imageData.length > 0
              ? imageData.map((image) => (
                  <tr key={image.id}>
                    <td>{image.id}</td>
                    <td>{image.fileName || image.name}</td>
                    <td>
                    {image && image.id ? (
                      image.present === false ? (
                        <MdOutlineImageNotSupported className="thumbnail imageUnavailable" size={48} title="Image not available" />
                      ) : (
                        <img
                          className="thumbnail"
                          src={RightTimeApi.URL("/Image/" + image.id)}
                          alt={image.fileName || image.name}
                        />
                      )
                    ) : null}
                    </td>
                    <td>
                      <button data-imageid={image.id} onClick={onDeleteFileAsync}>
                        <IoTrashOutline />
                      </button>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
        </div>
        <input
          type="file"
          name="image"
          multiple={true}
          ref={fileInputRef}
          onChange={onSelectImageAsync}
          style={{ display: "none" }} // Hide the file input
        />
      </>
    );
  } else {
    return null;
  }
}

